(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["load-more-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('load-more')) {
    class LoadMore extends HTMLElement {
      constructor() {
        super();
        this.link = this.querySelector('.load-more__link');
        this.formStatus = this.querySelector('.load-more__status');
        this.type = this.dataset.type || 'next';
        this.pageBuffer = 1;
        this.boundOnFiltersUpdate = this.onFiltersUpdate.bind(this);

        if (this.type === 'prev') {
          this.initObserver();
        } else {
          this.bindEvents();
        }

        // Listen for filter updates
        document.addEventListener('theme:filters:update', this.boundOnFiltersUpdate);
      }

initObserver() {
        const options = {
          rootMargin: '0px',
          threshold: 1
        };

        const observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            this.onClick({
              preventDefault: () => {},
              currentTarget: this.link
            });
          }
        }, options);

        observer.observe(this);
      }

      bindEvents() {
        if (this.link) {
          this.link.addEventListener('click', this.onClick.bind(this));
        }
      }

      onFiltersUpdate(e) {
        const searchParams = e.detail.searchParams;

        if (this.link) {
          const currentUrl = new URL(this.link.href);
          const sectionId = currentUrl.searchParams.get('section_id');

          // Clear all search params
          currentUrl.search = '';

          // Apply new search params from filters (these include sort_by and filter params)
          if (searchParams instanceof URLSearchParams) {
            for (const [key, value] of searchParams.entries()) {
              currentUrl.searchParams.append(key, value);
            }
          }

          // Don't add page parameter yet - fetch page 1 to check if page 2 exists
          currentUrl.searchParams.set('page', '1');

          // Add section_id for the fetch
          if (sectionId) {
            currentUrl.searchParams.set('section_id', sectionId);
          }

          this.checkIfNextPageExistsAfterFilters(currentUrl);
        }
      }

      async checkIfNextPageExistsAfterFilters(url) {
        try {
          const response = await fetch(url.toString());
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fetchedLoadMore = doc.querySelector(`load-more[data-type="${this.type === 'prev' ? 'prev' : 'next'}"]`);

          if (fetchedLoadMore) {
            const hasNext = fetchedLoadMore.dataset.hasNext === 'true';

            if (hasNext) {
              const nextUrl = new URL(url.toString());
              const nextPage = this.type === 'next' ? '2' : '1';
              nextUrl.searchParams.set('page', nextPage);
              this.link.href = nextUrl.toString();
              this.style.display = '';
              this.link.style.display = '';
            } else {
              this.style.display = 'none';
            }
          } else {
            this.style.display = 'none';
          }
        } catch (error) {
          this.style.display = 'none';
        }
      }      async onClick(e) {
        e.preventDefault();

        const link = e.currentTarget;
        const href = link.href;
        const sectionId = link.dataset.sectionId;
        const newUrl = this.createNewUrl(href, sectionId);
        const { pathname, search } = newUrl;

        this.enableLoading();

        try {
          const newSection = await this.getNewSection(pathname, search);
          this.disableLoading();
          this.updateURL(search);
          this.renderSection(newSection, this.type);

          // Dispatch custom events for other components
          document.dispatchEvent(new CustomEvent('theme:collection:loaded'));
        } catch (error) {
          console.error('Error loading more products:', error);
          this.disableLoading();
        }
      }

      renderSection(html, type) {
        const wrapper = this.getWrapper(html);
        const page = this.dataset.page;
        const productsWrapper = document.querySelector('[data-products-wrapper]');

        const newProducts = [...wrapper.querySelectorAll('[data-product-item]')].map(item => item.outerHTML);

        if (productsWrapper && newProducts.length > 0) {
          const insertPosition = type === 'prev' ? 'afterbegin' : 'beforeend';
          productsWrapper.insertAdjacentHTML(insertPosition, newProducts.join(''));
        }

        // Get the new load-more element to extract data
        const newLoadMore = wrapper.querySelector(`load-more[data-type="${type === 'prev' ? 'prev' : 'next'}"]`);
        const newLink = newLoadMore ? newLoadMore.querySelector('.load-more__link') : null;
        const newDataPage = newLoadMore ? newLoadMore.dataset.page : null;

        if (newLink && this.link) {
          const newHref = newLink.href;
          if (newHref && !newHref.includes('NaN')) {
            this.link.href = newHref;
            this.style.display = '';
          }
        } else {
          this.style.display = 'none';
        }

        if (newDataPage && newDataPage !== 'NaN') {
          this.dataset.page = newDataPage;
        }

        // Scroll to first new product
        const firstNewProduct = [...productsWrapper.children].find(
          item => item.getBoundingClientRect().top >= 0
        );

        if (firstNewProduct) {
          const offsetHeight = window.innerWidth > 992
            ? firstNewProduct.offsetHeight * 17
            : firstNewProduct.offsetHeight * 21;
          this.freeProductGrid(parseInt(page));
        }

        // Re-initialize any data-islands in the new content
        if (window.Shopify && window.Shopify.PageClickParser) {
          window.Shopify.PageClickParser.trigger(productsWrapper);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('theme:filters:update', this.boundOnFiltersUpdate);
      }

      freeProductGrid(page) {
        const products = Array.from(document.querySelectorAll('[data-product-item]'));
        const pageMin = page - this.pageBuffer;
        const pageMax = page + this.pageBuffer;

        let firstVisible = null;
        let lastVisible = null;

        for (let i = 0; i < products.length; i++) {
          const productPage = parseInt(products[i].dataset.page);

          if (productPage < pageMin || productPage > pageMax) {
            products[i].remove();
          } else {
            if (!firstVisible) firstVisible = products[i];
            lastVisible = products[i];
          }
        }

        const loadMoreButtons = Array.from(document.querySelectorAll('load-more'));

        for (let i = 0; i < loadMoreButtons.length; i++) {
          const button = loadMoreButtons[i];
          const link = button.querySelector('.load-more__link');

          if (!link) {
            continue;
          }

          const url = new URL(link.href);

          if (button.dataset.type === 'prev') {
            const newPage = firstVisible ? parseInt(firstVisible.dataset.page) - 1 : pageMin - 1;
            button.dataset.page = newPage;
            url.searchParams.set('page', newPage);
            link.href = url.toString();
          } else {
            const newPage = lastVisible ? parseInt(lastVisible.dataset.page) + 1 : pageMax + 1;
            button.dataset.page = newPage;
            url.searchParams.set('page', newPage);
            link.href = url.toString();
          }
        }
      }

      enableLoading() {
        this.link.setAttribute('disabled', true);
        this.setAttribute('data-is-loading', 'true');
        document.activeElement.blur();
        this.formStatus.setAttribute('aria-hidden', 'false');
      }

      disableLoading() {
        this.setAttribute('data-is-loading', 'false');
        this.formStatus.setAttribute('aria-hidden', 'true');
        this.link.removeAttribute('disabled');
      }

      createNewUrl(href, sectionId) {
        const url = new URL(href, window.location.origin);
        url.searchParams.append('section_id', sectionId);
        return url;
      }

      updateURL(search) {
        const params = new URLSearchParams(search);
        params.delete('section_id');

        if (params.get('page') === '1') {
          params.delete('page');
        }

        const queryString = params.toString();
        const newUrl = `${window.location.pathname}${queryString.length ? '?' : ''}${queryString}`;
        history.replaceState({}, '', newUrl);
      }

      async getNewSection(pathname, search) {
        const response = await fetch(`${pathname}${search}`);
        return await response.text();
      }

      getWrapper(html = '') {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.querySelector('[data-products-wrapper]');
      }
    }

    customElements.define('load-more', LoadMore);
  }
  } catch(e) { console.error(e); }
})();

})();
